import { render, staticRenderFns } from "./WorkingFileDetails.vue?vue&type=template&id=6a60ee39&scoped=true&"
import script from "./WorkingFileDetails.vue?vue&type=script&lang=js&"
export * from "./WorkingFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./WorkingFileDetails.vue?vue&type=style&index=0&id=6a60ee39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60ee39",
  null
  
)

export default component.exports